module.exports = __webpack_public_path__ + "img/top_option-3.3bade0e0.png";